import ConnectMarketplace from '../ConnectMarketplaceNew';
import ConnectGlamiForm, { createValidationSchema } from './ConnectGlamiForm';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import ConnectMarketplaceWizard, { ConnectMarketplaceWizardProps } from '../ConnectMarketplaceWizard';
import ConnectMarketplaceHeader from '../ConnectMarketplaceHeader';
import { MarketplaceRegion } from 'src/graphql/generated';
import { ConnectGlamiStepBloc } from './ConnectGlamiStepBloc';
import { ConnectMarketplaceWizardBloc } from '../ConnectMarketplaceWizardBloc';

interface ConnectGlamiOrchestratorProps {
    region: MarketplaceRegion;
    showWizardComponents: boolean;
}

export const ConnectGlamiOrchestrator: FunctionComponent<ConnectGlamiOrchestratorProps> = ({
    region,
    showWizardComponents,
}) => {
    const { t } = useTranslation();
    const parentBloc = new ConnectMarketplaceWizardBloc(1, region, t);
    const step1Bloc = new ConnectGlamiStepBloc(region, parentBloc, null, t);
    return (
        <ConnectGlami
            region={region}
            bloc={parentBloc}
            stepBlocs={[step1Bloc]}
            i18nPrefix="connectGlami"
            showWizardComponents={showWizardComponents}
        />
    );
};

const ConnectGlami: FunctionComponent<ConnectMarketplaceWizardProps> = (props) => {
    const { t } = useTranslation();

    return (
        <ConnectMarketplaceWizard {...props}>
            <ConnectMarketplace
                header={ConnectMarketplaceHeader}
                form={ConnectGlamiForm}
                validationSchema={createValidationSchema(t)}
            />
        </ConnectMarketplaceWizard>
    );
};
export default ConnectGlami;
